import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Wrapper, MenuItem } from './styled';

class Menu extends Component {
    static propTypes = {
        items: PropTypes.array,
        activeItem: PropTypes.number,
    };

    constructor(props) {
        super(props);

        this.state = {
            activeItemIndex: 0
        };
    }

    render() {
        const { items, activeItem } = this.props;

        const menuItems = items.map((item, idx) => {
            return (
                <MenuItem key={idx} active={activeItem === idx} onClick={() => {
 this.onMenuItemClickHandler(idx, item.route);
}}>
                    <span>{item.text}</span>
                </MenuItem>
            );
        });
        return (
            <Wrapper>
                {menuItems}
            </Wrapper>
        );
    }

    onMenuItemClickHandler = (key, type) => {
        this.props.typeHandler(type);
        this.setState({
            activeItemIndex: key
        });
    }
}

export default Menu;
